export enum NewsRcExternalFilterField {
  Type = 'type',
}
